/**
 * Componente Button
 * Botón reutilizable con diferentes variantes de estilo
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Botón genérico reutilizable
 * @param {Object} props - Propiedades del componente
 * @param {string} props.variant - Variante del botón ('primary', 'secondary', 'outline')
 * @param {Function} props.onClick - Función a ejecutar al hacer click
 * @param {ReactNode} props.children - Contenido del botón
 * @param {string} props.className - Clases CSS adicionales
 * @param {string} props.type - Tipo de botón HTML
 * @param {boolean} props.disabled - Si el botón está deshabilitado
 * @returns {JSX.Element} Componente de botón
 */
const Button = ({
  variant = 'primary',
  onClick,
  children,
  className = '',
  type = 'button',
  disabled = false,
}) => {
  const baseClasses = 'px-6 py-3 rounded-card font-lato font-semibold text-button transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';

  const variantClasses = {
    primary: 'bg-intercasa-red text-white hover:bg-red-800 focus:ring-intercasa-red shadow-md hover:shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed',
    secondary: 'bg-intercasa-yellow text-intercasa-dark hover:bg-yellow-400 focus:ring-intercasa-yellow shadow-md hover:shadow-lg disabled:bg-gray-300 disabled:cursor-not-allowed',
    outline: 'border-2 border-intercasa-red text-intercasa-red hover:bg-intercasa-red hover:text-white focus:ring-intercasa-red disabled:border-gray-400 disabled:text-gray-400 disabled:cursor-not-allowed',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Button;
